
// Define constants for different elements
const imageCaptionWrap = document.querySelector( '#intro-image-caption' );
const imageCaptionButton = document.querySelector( '#intro-image-caption-button' );


// Listen for a click on the button
if ( imageCaptionButton ) {

	imageCaptionButton.addEventListener( 'click', function( event ) {

		// If the aria-expanded attribute is false
		if ( imageCaptionButton.getAttribute( 'aria-expanded' ) === 'false' ) {

			// Add class to the wrapper
			imageCaptionWrap.classList.add( 'is-expanded' );

			// Update the aria-expanded attribute on the button
			imageCaptionButton.setAttribute( 'aria-expanded', 'true' );

			// Otherwise the aria-expanded attribute is true
		} else {

			// Remove class from wrapper
			imageCaptionWrap.classList.remove( 'is-expanded' );

			// Update the aria-expanded attribute on the button
			imageCaptionButton.setAttribute( 'aria-expanded', 'false' );

		}

	} );

}
